import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PasswordUpdateState {
    isLoading: boolean;
    isUpdateSuccess: boolean;
    isUpdateError: string;
}

const initialState: PasswordUpdateState = {
    isLoading: false,
    isUpdateSuccess: false,
    isUpdateError: "",
}

const passwordUpdateSlice = createSlice({
    name: 'passwordUpdate',
    initialState,
    reducers: {
        updatePasswordStart: (state: PasswordUpdateState) => {
            state.isLoading = true;
            state.isUpdateSuccess = false;
            state.isUpdateError = '';
        },
        updatePasswordSuccess: (state: PasswordUpdateState) => {
            state.isLoading = false;
            state.isUpdateSuccess = true;
            // state.isUpdateSuccess = action.payload.success;
            state.isUpdateError = '';
        },
        updatePasswordError: (state: PasswordUpdateState, action: PayloadAction<string>) => {
            state.isLoading = false;
            state.isUpdateSuccess = false;
            state.isUpdateError = action.payload || 'Failed to update password';
        },
    },
});

export const {
    updatePasswordStart,
    updatePasswordSuccess,
    updatePasswordError,
} = passwordUpdateSlice.actions;
export default passwordUpdateSlice.reducer;

